<template>
    <Menu
        v-slot="{ shown }"
        ref="menu"
        data-testid="locale-switcher"
        class="min-w-fit flex items-center m-0"
        placement="bottom-start"
        :options="menuOptions"
        :theme="isMD ? 'floatMenu' : 'sdMenu'"
        :triggers="['click']"
    >
        <BtnCta
            variant="tertiary"
            compact
            size="md"
            class="flex items-center p-0 m-0"
            icon="globe-flat"
        >
            <div class="flex items-center space-x-2">
                <div>{{ $t(`locales.${locale}`) }}</div>
                <i :class="['icon w-6 h-6', shown ? 'icon-chevron-up' : 'icon-chevron-down']"></i>
            </div>
        </BtnCta>
    </Menu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { availableLocales } from '@/utils/langUtils';
import { type MenuOption } from '@/components/Menu';
import { mapState, mapActions } from 'pinia';
import { useUIStore } from '@/stores/ui';
import { useScreenSize } from '@/composables/screenSize';

/**
 * This component allows user to change the app locale by clicking on the button. locales
 * are pulled from utils/langUtils, selected locale & setting new locale in vuex store.
 */
export default defineComponent({
    name: 'LocaleSwitcher',
    i18nOptions: {
        namespaces: ['common'],
    },
    setup() {
        return {
            isMD: useScreenSize().isMD,
        };
    },
    data() {
        return {
            locales: availableLocales,
        };
    },
    computed: {
        ...mapState(useUIStore, ['locale']),
        menuOptions(): MenuOption[] {
            return this.locales
                .map((locale) => ({
                    label: this.$t(`locales.${locale}`),
                    onclick: () => this.setLocale(locale),
                }))
                .sort((a, b) => a.label.localeCompare(b.label));
        },
    },
    methods: {
        ...mapActions(useUIStore, ['setLocale']),
    },
});
</script>
